module.exports = __webpack_public_path__ + "static/media/delete.32566939.svg";